import { createContext, useContext } from "react"
import { IToastProvider } from "../types";

export const ToastContext = createContext({} as IToastProvider);

export function useToast() {
    return useContext(ToastContext);
}